import './imagePopup.scss';
import ImagePopupController from "./imagePopupController";

/**
 * @param imgSrc - source of the shown image
 * @type {{template: *, controller: ImagePopupController, bindings: {imgSrc: string}}}
 */
const ImagePopupComponent = {
    template: require('./imagePopupView.html'),
    controller: ImagePopupController,
    bindings: {
        imgSrc: '<',
        customClass: '<'
    },
};

export default angular.module('app.imagePopup', [])
    .component('imagePopup', ImagePopupComponent)
    .name;




// WEBPACK FOOTER //
// ./src/app/components/imagePopup/imagePopupComponent.js